// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';
import { deliveryData } from 'shared/layouts/DetailsPage/components/Analytics/helpers';
import { DeliveryDataInterface } from 'shared/layouts/DetailsPage/components/Analytics/types';
import isEmpty from 'lodash/isEmpty';
import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

interface PincodeApplyParams {
  deliveryDetails?: DeliveryDataInterface;
  previousPincode?: string;
  pincodeOnPdp?: string;
  pdpCheckDeliveryErrorMessage?: string;
}

export const onPincodeApply = ({
  deliveryDetails,
  previousPincode,
  pincodeOnPdp,
  pdpCheckDeliveryErrorMessage,
}: PincodeApplyParams) => {
  let deliveryDataObject;

  if (!isEmpty(deliveryDetails)) {
    deliveryDataObject = deliveryData({ deliveryDataForSKUs: deliveryDetails });
  }

  if (previousPincode !== '') {
    NFA.track({
      event: PDP_EVENTS.PDP_CHANGE_DELIVERY_PINCODE,
      type: TRACK_TYPE.EVENT,
      data: {
        estimatedDeliveryDate: deliveryDataObject?.minDelivery
          ? deliveryDataObject?.minDelivery
          : undefined,
        pincodeOnPdp: pincodeOnPdp == '' ? undefined : pincodeOnPdp,
        pdpPincodeSelectionType: 'manualPincode',
        pdpCheckDeliveryErrorMessage,
        currentPage: null,
      },
    });
  } else {
    NFA.track({
      event: PDP_EVENTS.EVENT_ON_PDP_CHECK_DELIVERY,
      type: TRACK_TYPE.EVENT,
      data: {
        estimatedDeliveryDate: deliveryDataObject?.minDelivery
          ? deliveryDataObject?.minDelivery
          : undefined,
        pdpCheckDeliveryErrorMessage,
        pincodeOnPdp: pincodeOnPdp == '' ? undefined : pincodeOnPdp,
      },
    });
  }
};
